export interface LabelChange {
  label: string;
  replace: string;
}